import React from 'react';
import ReactDOM from 'react-dom/client';
import './app/globals.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ToastProvider } from '@/components/ui/use-toast';

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <ToastProvider>
      <App />
    </ToastProvider>
  </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
